<!-- Прямая ссылка из ПЛАНа заказа в настройки использованного калькулятора. -->
<template>
  <router-link
    class="plan-calculator-settings"
    :class="{ 'plan-calculator-settings--with-label': label }"
    :to="settingsRoute"
    target="_blank"
    rel="noopener noreferrer"
    :aria-label="accessibleLabel"
    :title="accessibleLabel"
  >
    <AppIcon name="settings" :size="14" aria-hidden="true" />
    <span v-if="label">{{ label }}</span>
  </router-link>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "OrderPlanCalculationSettingsButton",

  components: { AppIcon },

  props: {
    presetId: { type: [String, Number], required: true },
    calculatorName: { type: String, default: "" },
    label: { type: String, default: "" },
  },

  computed: {
    settingsRoute() {
      return {
        name: "CalculatorPresetDetails",
        params: { id: this.presetId },
      };
    },
    accessibleLabel() {
      return this.calculatorName
        ? `Настроить калькулятор «${this.calculatorName}» в новой вкладке`
        : "Настроить калькулятор в новой вкладке";
    },
  },
};
</script>

<style scoped>
.plan-calculator-settings {
  width: 24px;
  height: 24px;
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 6px;
  color: #5b6070;
  text-decoration: none;
}

.plan-calculator-settings:hover,
.plan-calculator-settings:focus-visible {
  background: #eef1f8;
  color: #3b5bdb;
  outline: none;
}

.plan-calculator-settings--with-label {
  width: auto;
  gap: 5px;
  padding: 0 7px;
  color: #3b5bdb;
  font-size: 12px;
  font-weight: 500;
}
</style>
